import { StructuredData } from './StructuredData';
import { CONTENT_REVIEWED, PUBLISHER, WEBSITE_ID } from '@/seo/organization';
import { ogImageFor } from '@/seo/ogImage';

interface PageStructuredDataProps {
  name: string;
  description: string;
  url: string;
  breadcrumbs?: { name: string; url?: string }[];
  type?: 'WebPage' | 'AboutPage' | 'ContactPage' | 'CollectionPage' | 'FAQPage';
  dateModified?: string;
}

export function PageStructuredData({ name, description, url, breadcrumbs, type = 'WebPage', dateModified = CONTENT_REVIEWED }: PageStructuredDataProps) {
  const image = ogImageFor(url);
  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': type,
    '@id': `${url}#webpage`,
    name,
    description,
    url,
    inLanguage: 'en',
    isPartOf: { '@id': WEBSITE_ID },
    publisher: PUBLISHER,
    dateModified,
    ...(image ? { primaryImageOfPage: { '@type': 'ImageObject', url: image } } : {}),
  };

  const items = [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://beatview.ai' },
    ...(breadcrumbs || [{ name }]).map((b, i) => ({
      '@type': 'ListItem',
      position: i + 2,
      name: b.name,
      ...(b.url ? { item: b.url } : {}),
    })),
  ];

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items,
  };

  return <StructuredData data={[webPageSchema, breadcrumbSchema]} />;
}
